var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('div', [_c('router-view'), _c('div', {
    staticClass: "bottom-wrapper"
  }, [_c('bottom-nav')], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }